import { useEffect, useState } from "react";
import { ReservationDetailData } from "../../api/ApiData";
import { Stack, Typography } from "@mui/material";
import PageWrapper from "../PageWrapper";
import Space from "../Space";
import { ColorHexCodes } from "../../util/Color";
import CancellableReservationSummary from "../CancellableReservationSummary";
import { useApiContext } from "../../api/ApiProvider";
import lineLogin from "../../img/line_login.png";

export default function ReservationDetail() {
  const { api } = useApiContext();
  const [reservationDetailData, setReservationDetailData] = useState<ReservationDetailData | null>();
  const searchParams = new URLSearchParams(window.location.search);
  const rid = searchParams.get("rid");

  useEffect(() => {
    if (rid) {
      api.getReservationData(rid).then((data) => setReservationDetailData(data));
    }
  }, [rid]);

  if (reservationDetailData === undefined) {
    return <>予約情報を取得中</>;
  }

  if (reservationDetailData === null) {
    return <>該当する予約はありません</>;
  }

  return (
    <PageWrapper storeGroupName={reservationDetailData.group.show_group_name ? reservationDetailData.group.name : ""}>
      <Typography fontSize="26px" textAlign="center">
        ご予約詳細
      </Typography>
      <Space h={20} />
      <Stack style={{ backgroundColor: "white", padding: "20px 30px" }}>
        {reservationDetailData.lineLoginUrl && (
          <div>
            <Stack direction="row" alignItems="center" spacing={2}>
              <Typography>LINEログインして予約通知を受け取る</Typography>
              <a href={reservationDetailData.lineLoginUrl} target="_blank" rel="noopener noreferrer">
                <img src={lineLogin} width="110" height="32" alt="Line login" />
              </a>
            </Stack>
            <Space h={15} />
            <div style={{ height: 1, background: `#${ColorHexCodes.MainColorGreen}` }} />
            <Space h={15} />
          </div>
        )}
        <CancellableReservationSummary data={{ ...reservationDetailData }} />
      </Stack>
    </PageWrapper>
  );
}
